import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'masterVEHlist': [],
  'jdeLoading': false,
  'jdeList': {},
  'auditList': [],
  'classesList': [],
};

const INITIAL_STATE_IMAGE = {
  'imagesLoading': false,
  'images': [],
  'rowImages': [],
};

const FORM_VALUES = {
  'katashiki': '',
  'sfxProvider': '',
  'sfx': '',
  'description': '',
  'airConditioning': '',
  'cabinType': '',
  'category': 'N/A-NO APLICA',
  'segment': 'N/A-NO APLICA',
  'subSegment': 'N/A-NO APLICA',
  'family': 'N/A-NO APLICA',
  'traction': 'N/A-NO APLICA',
  'transmission': 'N/A-NO APLICA',
  'doorsNumber': 'N/A-NO APLICA',
  'passengers': 'N/A-NO APLICA',
  'fuel': 'N/A-NO APLICA',
  'country': '',
  'weight': 0,
  'volume': 0,
  'chargeCapacity': 0,
  'wholeWeight': 0,
  'cilindraje': 0,
  'potency': 0,
  'state': '',
  'ice': 0,
  'variableIce': 0,
  'iva': 15,
  'salesPrice': 0,
  'ivaInvoicing': '6-Vehículos Con IVA',
  'vehClass': 0,
  'vehClassDescription': '',
  'sriClass': 'N/A-NO APLICA',
  'sriType': 'N/A-NO APLICA',
  'tariffHeading': 'N/A-NO APLICA',
  'inen': 'N/A',
  'hybrid': 'N/A-NO APLICA',
  'tonnage': 0,
  'vehicleId': 0,
  'vehicleName': '',
  'vehicleState': true,
  'modelName': '',
  'aditionals': [],
  'filesCharge': 'S',
  'salesDate': '',
  'cuhv': '',
  'esGoshi': false,
};

const FORM_INITIAL_STATE = {
  'loading': false,
  'loadingColors': false,
  'saving': false,
  'editKatashikiAndSfxTDE': true,
  'initialValues': FORM_VALUES,
  'initialColors': [{}],
  'values': {
    ...FORM_VALUES,
    'colorList': [{}],
  },
};

export const masterVehicle = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_MASTER_VEHICLES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_MASTER_VEHICLES_LIST]: (state, action) => ({
      ...state,
      'masterVEHlist': action.response.data,
      'loading': false,
    }),
    [ActionTypes.FETCHED_MASTER_VEHICLES_LIST_FAILED]: (state, action) => ({
      ...state,
      'masterVEHlist': [],
      'loading': false,
    }),
    [ActionTypes.FETCHING_JDE_PARAMETERS]: (state, action) => ({
      ...state,
      'jdeLoading': true,
    }),
    [ActionTypes.FETCHED_JDE_PARAMETERS]: (state, action) => ({
      ...state,
      'jdeList': action.response.data,
      'jdeLoading': false,
    }),
    [ActionTypes.FETCHED_JDE_PARAMETERS_FAILED]: (state, action) => ({
      ...state,
      'jdeList': {},
      'jdeLoading': false,
    }),
    [ActionTypes.FETCHING_VEHICLE_MASTER_AUDIT]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_VEHICLE_MASTER_AUDIT]: (state, action) => ({
      ...state,
      'loading': false,
      'auditList': action.response.data,
    }),
    [ActionTypes.FETCHED_VEHICLE_MASTER_AUDIT_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'auditList': [],
    }),
  })(state, action);
};

export const masterVehicleForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.DELETE_MASTERVEH_DATA]: (state) => ({
      ...state,
      ...FORM_INITIAL_STATE,
      'values': {
        ...state.values,
        ...FORM_INITIAL_STATE.values,
        'state': 'PRODUCTO',
        'airConditioning': false,
        'vehicleState': true,
      },
    }),
    [ActionTypes.FETCHING_CLASSES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_CLASSES]: (state, action) => ({
      ...state,
      'classesList': action.response.data,
      'loading': false,
    }),
    [ActionTypes.FETCHED_CLASSES_FAILED]: (state, action) => ({
      ...state,
      'classesList': [],
      'loading': false,
    }),
    [ActionTypes.FETCHING_MASTER_VEH]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_MASTER_VEH]: (state, action) => {
      const data = action.response.data;
      data.airConditioning = data.airConditioning === 'S';
      data.vehicleState = data.vehicleState === 'A';
      return ({
        ...state,
        'loading': false,
        'editKatashikiAndSfxTDE': action.response.editKatashikiAndSfxTDE,
        'initialValues': data,
        'values': {
          ...state.values,
          'code': data.code,
          'katashiki': data.katashiki,
          'sfxProvider': data.sfxProvider,
          'sfx': data.sfx,
          'description': data.description,
          'airConditioning': data.airConditioning,
          'cabinType': data.cabinType,
          'category': data.category || 'V/P-Valor pendiente',
          'segment': data.segment || 'V/P-Valor Pendiente',
          'subSegment': data.subSegment || 'V/P-Valor Pendiente',
          'family': data.family || 'V/P-Valor Pendiente',
          'traction': data.traction || 'V/P-Valor Pendiente',
          'transmission': data.transmission || 'V/P-Valor Pendiente',
          'doorsNumber': data.doorsNumber || 'V/P-Valor Pendiente',
          'passengers': data.passengers || 'V/P-Valor Pendiente',
          'fuel': data.fuel || 'V/P-Valor Pendiente',
          'weight': data.weight || 0,
          'volume': data.volume || 0,
          'chargeCapacity': data.chargeCapacity || 0,
          'wholeWeight': data.wholeWeight || 0,
          'cilindraje': data.cilindraje || 0,
          'potency': data.potency || 0,
          'country': data.country,
          'state': data.state || 'PRODUCTO',
          'ice': data.ice || 0,
          'variableIce': data.variableIce || 0,
          'iva': data.iva || 0,
          'salesPrice': data.salesPrice || 0,
          'ivaInvoicing': data.ivaInvoicing || 'N-Sin IVA',
          'vehClass': data.vehClass,
          'vehClassDescription': data.vehClassDescription,
          'sriClass': data.sriClass || 'V/P-Valor Pendiente',
          'sriType': data.sriType || 'V/P-Valor Pendiente',
          'tariffHeading': data.tariffHeading || 'V/P-Valor Pendiente',
          'inen': data.inen || 'V/P',
          'hybrid': data.hybrid || 'V/P-Valor Pendiente',
          'tonnage': data.tonnage || 0,
          'vehicleId': data.vehicleId ? parseInt(data.vehicleId, 10) : 0,
          'vehicleName': data.vehicleName,
          'vehicleState': data.vehicleState,
          'modelName': data.modelName,
          'aditionals': action.response.aditionals,
          'filesCharge': data.filesCharge,
          'salesDate': data.salesDate,
          'cuhv': data.cuhv || '',
          'esGoshi': data.esGoshi || false,
        },
      });
    },
    [ActionTypes.FETCHED_MASTER_VEH_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'editKatashikiAndSfxTDE': true,
      'values': {
        ...state.values,
        ...FORM_INITIAL_STATE.values,
      },
    }),
    [ActionTypes.FETCHING_MASTER_VEH_COLOR]: (state, action) => ({
      ...state,
      'loadingColors': true,
    }),
    [ActionTypes.FETCHED_MASTER_VEH_COLOR]: (state, action) => ({
      ...state,
      'loadingColors': false,
      'initialColors': action.response.data,
      'values': {
        ...state.values,
        'colorList': action.response.data,
      },
    }),
    [ActionTypes.FETCHED_MASTER_VEH_COLOR_FAILED]: (state, action) => ({
      ...state,
      'loadingColors': false,
      'values': {
        ...state.values,
        'colorList': [{}],
      },
    }),
    [ActionTypes.UPDATE_REQUEST_STATE]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'state': action.payload,
      },
    }),
    [ActionTypes.CREATING_MASTER_VEH]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.CREATED_MASTER_VEH]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.CREATED_MASTER_VEH_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.UPDATING_MASTER_VEH]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.UPDATED_MASTER_VEH]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.UPDATED_MASTER_VEH_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.UPDATING_REJECT_MASTER_VEH]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.UPDATED_REJECT_MASTER_VEH]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.UPDATED_REJECT_MASTER_VEH_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
  })(state, action);
};
const urltoFile = async(url, filename, mimeType) => {
  const res = await fetch(url);
  const buf = await res.arrayBuffer();
  return new File([buf], filename, {'type': mimeType});
};
const convertBase64ToFiles = (attachments) => {
  const files = [];
  if (attachments) {
    attachments.forEach(async(item) => {
      const base64 = `data:image/jpeg;base64,${item.file}`;
      return await urltoFile(base64, item.name, item.mimetype).then((file) => files.push(file));
    });
  }
  return files;
};
export const masterVehicleImages = (state, action) => {
  return createReducer(INITIAL_STATE_IMAGE, {
    [ActionTypes.FETCHING_MASTER_VEHICLE_ATTACHMENTS]: (state, action) => ({
      ...state,
      'imagesLoading': true,
    }),
    [ActionTypes.FETCHED_MASTER_VEHICLE_ATTACHMENTS]: (state, action) => {
      return {
        ...state,
        'imagesLoading': false,
        'images': convertBase64ToFiles(action.response.data),
        'rowImages': action.response.data,
      };
    },
    [ActionTypes.FETCHED_MASTER_VEHICLE_ATTACHMENTS_FAILED]: (state, action) => ({
      ...state,
      'imagesLoading': false,
      'images': [],
      'rowImages': [],
    }),
    [ActionTypes.SET_IMAGE_FILES]: (state, action) => ({
      ...state,
      'images': action.payload,
    }),
  })(state, action);
};
